import { generateLanguageQuery } from '@/services/dataStore/queries/fragments'

export const costsQuery = () =>
  `*[_type == "cost"] {
    'key': _id,
    'nameI18n': ${generateLanguageQuery('name')},
    'definitionI18n': ${generateLanguageQuery('definition')},
    'category': {
      progressColor,
    },
    sortOrder,
    estimatedPercentOfTotal,
    'deprecated': deprecated == true,
  }`
